import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MppPageHeaderComponent } from './page-header.component';

@NgModule({
  declarations: [MppPageHeaderComponent],
  imports: [CommonModule],
  exports: [MppPageHeaderComponent],
})
export class MppPageHeaderModule {}
